module.exports = __webpack_public_path__ + "static/media/Waiting.a60d2741.svg";